/**
 * POSTopBar - Top navigation bar for POS terminal
 * Shows staff info, shift status, kiosk queue notification, and quick actions
 */
import { Coffee, Sun, Moon, LogOut, Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { POSShiftBadge } from '@/components/pos/POSShiftManager';

export default function POSTopBar({ 
  staff, 
  onLogout, 
  onToggleTheme, 
  theme, 
  pendingKioskOrdersCount, 
  onShowKioskQueue, 
  activeShift, 
  onEndShift 
}) {
  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Coffee className="w-6 h-6 text-teal-600" />
        <span className="font-semibold text-gray-900 dark:text-white">POS Terminal</span>
      </div>
      <div className="flex items-center gap-3">
        {/* Shift Status Badge */}
        {activeShift && (
          <POSShiftBadge shift={activeShift} onEndShift={onEndShift} />
        )}
        {pendingKioskOrdersCount > 0 && (
          <Button
            variant="outline"
            size="sm"
            onClick={onShowKioskQueue}
            className="text-amber-600 border-amber-300 hover:bg-amber-50"
          >
            <Bell className="w-4 h-4 mr-1" />
            {pendingKioskOrdersCount} Kiosk
          </Button>
        )}
        <span className="text-sm text-gray-500 dark:text-gray-400">
          Signed in as <span className="font-medium text-gray-900 dark:text-white">{staff?.name}</span>
        </span>
        <Button variant="ghost" size="sm" onClick={onToggleTheme} className="text-gray-500">
          {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
        <Button variant="ghost" size="sm" onClick={onLogout} className="text-red-500" data-testid="pos-logout-btn">
          <LogOut className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
